import apiClient from "./apiClient";

const get  = (url)       => apiClient.get(url).then((r) => r.data);
const post = (url, body) => apiClient.post(url, body).then((r) => r.data);

export const fetchLateOrders      = () => get("/live-late-orders");
export const fetchNewOrders       = () => get("/live-new-orders");
export const fetchPreparingOrders = () => get("/live-preparing-orders");
export const fetchAssignedOrders  = () => get("/live-assigned-orders");
export const fetchPickedUpOrders  = () => get("/live-pickedup-orders");
export const fetchCompletedOrders = () => get("/live-completed-orders");
export const fetchAwaitingOrders  = () => get("/live-awaiting-orders");
export const fetchCancelledOrders = () => get("/live-cancelled-orders");
export const fetchAvailableBoys   = () => get("/live-available-boys");
export const fetchDataFeed        = () => get("/live-data-feed");

export const fetchOrder = (orderId) =>
    post("/view-order", { order_id: orderId });

export const assignDeliveryFromAdmin = (orderId, userId, customerId) =>
    post("/order/assign-delivery-from-admin", { order_id: orderId, user_id: userId, customer_id: customerId });

export const reAssignDeliveryFromAdmin = (orderId, userId, customerId) =>
    post("/order/reassign-delivery", { order_id: orderId, user_id: userId, customer_id: customerId });

export const acceptOrderFromAdmin = (orderId) =>
    post("/order/accept-order", { id: orderId });

export const cancelOrderFromAdmin = (orderId, cancelReason, refundType) =>
    post("/order/cancel-order", { order_id: orderId, cancel_reason: cancelReason, refund_type: refundType });

export const updateOrderFromAdmin = (orderId, request) =>
    post(`/order/update-order/${orderId}`, request);


export const apiFetchDeliveryGuyLocation = async (userId) =>
    get(`/delivery-guy-location/${userId}`);


export const apiFetchAvailableDeliveryGuys = async () =>
    get(`/available-delivery-guys`);

export const apiFetchPageOrder = async (params) =>
    get(`/orders?${params}`);


export const apiFetchDeliveryGuys = async ({ search = "", page = 1, limit = 10, zone_id = null } = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (search.trim()) params.set("search",  search.trim());
    if (zone_id)       params.set("zone_id", zone_id);

    const res = await get(`/delivery-guys?${params}`);

    return {
        data:    res.data,
        hasMore: res.next_page_url !== null,
        total:   res.total,
    };
}
